/* Cart drawer extras: coupon row + one-tap upsell add.

   Deliberately small and deliberately FAIL-OPEN. If this file never loads, the
   coupon row submits nothing and the upsell buttons fall back to a normal form
   POST — a broken script must never be able to block a sale.

   The terms gate that used to live here is gone along with its markup. It also
   took a document-wide MutationObserver with it, which was re-querying the DOM
   on every mutation Judge.me and GoKwik made, forever, to look for a checkbox
   that no longer exists. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---- coupon code ----------------------------------------------------- */
  /* Shopify applies a code via /discount/<CODE>; the redirect brings the
     shopper back to the cart, where cart_level_discount_applications then
     renders the applied row. There is no cart-level AJAX endpoint for this. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cs-discount]');
    if (!form) return;
    e.preventDefault();

    var input = form.querySelector('input[name="discount"]');
    var msg = form.parentNode.querySelector('[data-cs-discount-msg]');
    var code = (input && input.value || '').trim();

    if (!code) {
      if (msg) { msg.textContent = 'Enter a code first.'; msg.hidden = false; }
      if (input) input.focus();
      return;
    }
    if (msg) { msg.textContent = 'Applying…'; msg.hidden = false; }
    window.location.href =
      root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart');
  });

  /* ---- upsell "+ ADD" -------------------------------------------------- */
  /* Each rail card is a real <form> posting to /cart/add, so it works without
     JS. But a plain POST redirects to /cart, which closes the drawer and dumps
     the shopper on another page — the opposite of what a drawer upsell is for.
     So: add over AJAX and re-render the drawer in place.

     Every branch that cannot do that returns WITHOUT preventDefault, letting
     the native POST happen rather than swallowing the click. */
  document.addEventListener('submit', function (e) {
    /* The Steal Deals card (snippets/cs-steal-deals.liquid) adds the same way. */
    var form = e.target.closest('.cs-upsell__card form, .cs-steal__card form');
    if (!form) return;

    var drawer = document.querySelector('cart-drawer');
    var id = form.querySelector('input[name="id"]');
    if (!drawer || !id || !id.value) return;
    if (typeof drawer.getSectionsToRender !== 'function') return;
    if (typeof drawer.renderContents !== 'function') return;

    e.preventDefault();

    var btn = form.querySelector('button');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    var sections = drawer.getSectionsToRender().map(function (s) { return s.section || s.id; });

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(id.value), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (!state || !state.sections) throw new Error('no sections');
        drawer.renderContents(state);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {
        /* Fall back to the page the no-JS path would have reached. */
        form.submit();
      });
  });
})();
